import { useCallback, useEffect, useState } from "react";
import { deleteData, fetchData, getAccessToken, postData, putData } from "../common/MSALHelper";
import { useMsal } from "@azure/msal-react";
import { useParams } from "react-router-dom";

export default function ReportYearlyContribution() {
    const { instance, accounts } = useMsal();
    const { year } = useParams();
    const [ reportData, setReportData ] = useState(null);

    useEffect(() => {
        //get years for the Receipts
        getAccessToken(instance, accounts).then(response => {
            fetchData(response, `/yearly_contribution_report/${year}`, res => {
                if (!res.ok)
                    throw new Error(`HTTP error! status: ${res.status}`);

                return res.json();
            }, data => {
                setReportData(data);
            })
        })
    }, [instance, accounts])

    if (!year || year.trim() === '') {
        return <div>Please specify a year in the URL (e.g., /ReportYearlyAll/2022)</div>;
    }

    return (
        <div>
            <h1>Contribution Report for {year}</h1>
            {reportData ? (
                <>
                    <div className="d-flex justify-content-between">
                        <h3>Total Count: {reportData.length}</h3>
                        <h3>Total Contribution: ${reportData.reduce((sum, item) => sum + item.Amount, 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h3>
                    </div>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Member ID</th>
                                <th>Last Name</th>
                                <th>Middle Name</th>
                                <th>First Name</th>
                                <th>Chi Hoi</th>
                                <th>Date</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportData.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.MemberID}</td>
                                    <td>{item.LastName}</td>
                                    <td>{item.MiddleName || '-'}</td>
                                    <td>{item.FirstName}</td>
                                    <td>{item.ChiHoi || '-'}</td>
                                    <td>{item.Date ? item.Date.split('T')[0] : '-'}</td>
                                    <td>${item.Amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between">
                        <h3>Total Count: {reportData.length}</h3>
                        <h3>Total Contribution: ${reportData.reduce((sum, item) => sum + item.Amount, 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h3>
                    </div>
                </>
            ) : (
                <p>Loading report data...</p>
            )}
        </div>
    );
}